import { render, staticRenderFns } from "./i4pro-card.vue?vue&type=template&id=6d2b490e&scoped=true"
import script from "./i4pro-card.vue?vue&type=script&lang=js"
export * from "./i4pro-card.vue?vue&type=script&lang=js"
import style0 from "./i4pro-card.vue?vue&type=style&index=0&id=6d2b490e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2b490e",
  null
  
)

export default component.exports